module.exports = __webpack_public_path__ + "img/objetos-35.038c94c9.png";